export default () => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'coolerNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: '冷藏箱编号',
  },
  {
    field: 'v_boxType',
    title: '箱型',
    align: 'center',
    width: 100,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'coolerLength',
    title: '冷藏箱长度',
    align: 'center',
    width: 150,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'coolerWidth',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: '冷藏箱宽度',
  },
  {
    field: 'coolerHeight',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: '冷藏箱高度',
  },
]
